import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as brands_actions from 'data/brands/actions';
import * as categories_actions from 'data/categories/actions';
import * as producttypes_actions from 'data/productTypes/actions';

import RaisedButton from 'material-ui/RaisedButton';
import { Page, PageSection, PageBlock, RightDrawer } from 'components/Page';

import Subheader from 'material-ui/Subheader';
import Row from 'components/Form/Row';
import MenuLink  from 'components/Navigation/MenuLink';
import ImageField  from 'components/Form/ImageField';

import Field from 'components/Form/Field';
import DropdownField  from 'components/Form/DropdownField';

class ProductTypeFormPage extends Component {
    state = { };

    static contextTypes = {
        router: PropTypes.object
    };

    handleCancel(id) {
        this.context.router.history.push("/admin/producttypes");
    }


    componentWillMount() {
        this.props.actions.fetchProducttype(this.props.params.id);
        this.props.actions.fetchProducttypes();//(this.props.params.id);
        this.props.actions.fetchBrands();
        this.props.actions.fetchCategories();
    }

    handleFormSubmit(event) {
        

        var data = _.map(this.refs, (r,i) => { return {[i]: r.state.value || ""} });
        let merged = Object.assign(...data);
        merged.imageAlt1Url = this.refs.imageAlt1.state.url || "";
        merged.imageAlt2Url = this.refs.imageAlt2.state.url || "";
        merged.imageAlt3Url = this.refs.imageAlt3.state.url || "";
        merged.themeimageUrl = this.refs.themeimage.state.url || "";
        this.props.actions.updateProducttype(this.props.params.id, merged);
    }
    onCheck = (event) => {
        
        return false;
    }
    render() {
        if (!this.props.producttype)
            {
                return null;
            }

        var { categories } = this.props;
        return [
            <RightDrawer key="right">
              <PageBlock label="Produkttyper" />
            </RightDrawer>,
            <Page key="page"  ready={!this.props.pending}>
                <Subheader>
	            <MenuLink label="Produkttyper" to="/admin/producttypes"/>
                    <span className="pathsep"></span>
	            <MenuLink label={this.props.producttype.name} to={this.props.params.id}/>
                </Subheader>
                <div onSubmit={this.handleFormSubmit.bind(this)} className="form-inline">
                    <PageSection label="Detaljer">
                        <Row>
                            <DropdownField ref="categoryid" value={this.props.producttype.categoryid} label="Kanal" options={categories} />
                        </Row>
                        <Row>
                            <Field ref="name" value={this.props.producttype.name} floatingLabelText="Rubrik"/>
                        </Row>
                        <Row>
                            <Field ref="subtitle" value={this.props.producttype.subtitle} floatingLabelText="Underrubrik"/>
                        </Row>
                        <Row>
                            <Field multiLine={true} ref="description" value={this.props.producttype.description} floatingLabelText="Beskrivning"/>
                        </Row>
                    </PageSection>
                    <PageSection label="Bilder">
                        <Row styleName="padded">
                            <ImageField ref="themeimage" value={this.props.producttype.themeimage} url={this.props.producttype.themeimageUrl} label="Produktbild 1, 400 x 400" />
                        </Row>
                        <Row styleName="padded">
                            <ImageField ref="imageAlt1" value={this.props.producttype.imageAlt1} url={this.props.producttype.imageAlt1Url} label="Produktbild 2, 400 x 400" />
                        </Row>
                        <Row styleName="padded">
                            <ImageField ref="imageAlt2" value={this.props.producttype.imageAlt2} url={this.props.producttype.imageAlt2Url} label="Produktbild 3, 400 x 400" />
                        </Row>
                        <Row styleName="padded">
                            <ImageField ref="imageAlt3" value={this.props.producttype.imageAlt3} url={this.props.producttype.imageAlt3Url} label="Produktbild 4, 400 x 400" />
                        </Row>
                    </PageSection>
                    <PageSection>
                        <Row styleName="padded">
                            <RaisedButton onTouchTap={this.handleFormSubmit.bind(this)}  primary={true} label="Spara" />
                            <RaisedButton onTouchTap={this.handleCancel.bind(this)} label="Stäng" />
                        </Row>
                    </PageSection>
                </div>
            </Page>
        ]
    }
}

function mapStateToProps(state, ownProps) {
    var producttype = state.producttypes.details.data
    var brandid = null;
    if (!producttype || !state.brands.list.data)
        {
            return {};
        }   
    brandid = producttype.brandid;
    return {
        producttype: producttype,
        brand: state.brands.list.data[brandid],
        brands: state.brands.list.data,
        categories: state.categories.list.data,
        pending: state.producttypes.details.pending
    };
}

const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...brands_actions , ...categories_actions , ...producttypes_actions}, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatch)(ProductTypeFormPage)





// WEBPACK FOOTER //
// ./src/pages/admin/producttypes/ProductTypeFormPage.jsx